import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';

const History = () => {
  const { user } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) navigate('/', { replace: true });
  }, [user, user?.id, navigate]);
  const items = user?.history || [];
  const [openId, setOpenId] = useState(null);

  if (!user) return null;

  return (
    <div className="profile-section">
      <div style={{ marginBottom: 16 }}>
        <button style={{ border: "1px solid #a261a7", color:"#a261a7"}}onClick={() => navigate('/profile')} className="back-button">← חזרה לאזור אישי</button>
      </div>
      <h3 style={{
  color: "#a261a7",
  display: "flex",
  justifyContent: "center",
  // alignItems: "center",
  gap: "8px"   // קצת רווח בין הכותרת לאייקון
}} > היסטוריית קניות ({items.length})
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#a261a7"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 2h14l2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" />
    <line x1="8" y1="10" x2="16" y2="10" />
    <line x1="8" y1="14" x2="16" y2="14" />
    <line x1="8" y1="6" x2="12" y2="6" />
  </svg>
      </h3>
      {items.length === 0 && <div>אין היסטוריית רכישות.</div>}

      <div className="history-container">
        {items.map((p, idx) => (
          <div key={p.id || idx} className="history-purchase-card">
            <div className="history-purchase-header" onClick={() => setOpenId(openId === p.id ? null : p.id)}>
              <div className="history-purchase-info">
                <div className="history-date">{p.date || p.createdAt || 'תאריך לא ידוע'}</div>
                <div className="history-total">סך: {p.total || p.amount || 0} ₪</div>
              </div>
              <div className="history-expand-icon">
                {openId === p.id ? '▼' : '▶'}
              </div>
            </div>
            {openId === p.id && (
              <div className="history-products-list">
                <div className="history-products-title">מוצרים שנקנו:</div>
                {(p.items || []).map(i => (
                  <div key={i.id || Math.random()} className="history-product-item">
                    <div className="history-product-name">{i.name}</div>
                    <div className="history-product-price">מחיר: {i.price} ₪</div>
                    {i.quantity && i.quantity > 1 && <div className="history-product-quantity">כמות: {i.quantity}</div>}
                  </div>
                ))}
                {p.note && <div className="history-note">{p.note}</div>}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default History;
